/**
 * @generated SignedSource<<83788552b0aa94f517262c6689d82beb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ApproveCurrencyTransactionDetails_metadata$data = {
  readonly sentAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly symbol: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"PaymentAssetMedia_asset">;
    };
  }>;
  readonly " $fragmentType": "ApproveCurrencyTransactionDetails_metadata";
};
export type ApproveCurrencyTransactionDetails_metadata$key = {
  readonly " $data"?: ApproveCurrencyTransactionDetails_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"ApproveCurrencyTransactionDetails_metadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApproveCurrencyTransactionDetails_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "sentAssetQuantities",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AssetType",
          "kind": "LinkedField",
          "name": "asset",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "symbol",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PaymentAssetMedia_asset"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};

(node as any).hash = "f14e01b837dfd7ff774284889a503d70";

export default node;
